import { useField } from "formik";

import { Toggle, ToggleProps } from "./Toggle";
import { FormFeedback } from "../_assets/input-wrapper/FormFeedback";
import {
  InputWrapper,
  InputWrapperProps,
} from "../_assets/input-wrapper/InputWrapper";

interface Props extends ToggleProps, Omit<InputWrapperProps, "children"> {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID?: string;
}

export function ToggleField({
  name,
  span = "auto",
  testID = "toggle-field",
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <Toggle
        isSelected={field.value}
        {...props}
        onChange={helpers.setValue}
        testID={testID}
      />
      <FormFeedback>{meta.touched && meta.error}</FormFeedback>
    </InputWrapper>
  );
}
